<template>
  <div>
    <LayoutTelaFiltros
      :titulo="this.$route.meta.titulo"
      :registros="listaClientes"
      :camposTabela="retornaCamposTabela()"
      ordenarPor="nome"
      :totalPaginas="totalDePaginas"
      :isLoading="isLoading"
      :arrBotoesAcao="botoesAcao"
      @buscarTodos="buscarTodos"
      @buscaFiltro="buscaFiltro"
      @clicouItemTabela="clicouItemTabela"
      @limpar="limpar" />

    <fab
      :position="floatButton.position"
      :bg-color="floatButton.bgColor"
      :fixed-tooltip="true"
      :actions="floatButton.fabActions"
      :start-opened="true"
      @cadastroClientes="cadastroClientes" />
  </div>
</template>

<script>
import fab from 'vue-fab'
import LayoutTelaFiltros from '@/components/layouts/LayoutTelaFiltros.vue'
import GeradorMensagens from '@/mixins/GeradorMensagens'

import ClienteService from '../../services/clientes.service'

const botaoFlutuante = {
  bgColor: '#003149',
  position: 'bottom-right',
  fabActions: [
    {
      name: 'cadastroClientes',
      icon: 'person_add',
      tooltip: 'Cadastrar clientes',
    },
  ],
}

export default {
  name: 'Clientes',
  components: {
    LayoutTelaFiltros,
    fab,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      listaClientes: [],
      totalDePaginas: 0,
      floatButton: botaoFlutuante,
      isLoading: false,
      botoesAcao: this.retornaBotoesAcaoLista(),
    }
  },
  methods: {
    async buscarTodos(pagina = 0) {
      this.mostrarLoader()
      try {
        const clientes = await ClienteService.retornaTodos(pagina)
        this.listaClientes = clientes.lista
        this.totalDePaginas = clientes.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    async buscaFiltro(filtro, pagina = 0) {
      this.mostrarLoader()
      try {
        const clientes = await ClienteService.retornaTodosPorFiltro(filtro, pagina)
        this.listaClientes = clientes.lista
        this.totalDePaginas = clientes.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    clicouItemTabela(item) {
      this.$router.push({
        name: 'rota-clientes-alteracao',
        params: { id: item._id },
      })
    },
    limpar() {
      this.listaClientes = []
      this.totalPaginas = 0
    },
    retornaCamposTabela() {
      return {
        nome: {
          label: 'Nome',
        },
        contato: {
          label: 'Contato',
        },
        whatsapp: {
          label: '',
        },
        instagram: {
          label: '',
        },
      }
    },
    cadastroClientes() {
      this.$router.push({ name: 'rota-clientes-cadastro' })
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
    retornaBotoesAcaoLista() {
      return [
        {
          _id: 'whats',
          slot: 'whatsapp',
          variant: 'success',
          icone: 'whatsapp',
          mostrar: function (item) {
            return item.contato && item.contato !== ''
          },
          acao: function (item) {
            if (item.contato) {
              const numero = item.contato.replace(/\D/g, '')
              window.open(`https://api.whatsapp.com/send?phone=${numero}`, '_blank')
            }
          },
        },
        {
          _id: 'insta',
          slot: 'instagram',
          variant: 'outline-primary',
          icone: 'instagram',
          mostrar: function (item) {
            return item.redesocial && item.redesocial !== ''
          },
          acao: function (item) {
            if (item.redesocial) {
              window.open(`https://www.instagram.com/${item.redesocial}`, '_blank')
            }
          },
        },
      ]
    },
  },
}

</script>
